var _path, _path2, _path3, _path4, _path5, _path6, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIpfs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 233,
    viewBox: "0 0 202 233",
    width: 202,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m100.845 232.993 100.727-58.198v-116.3132l-100.727 58.1152z",
    fill: "#35777a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m100.845 232.993v-116.509l-100.727324-58.0022v116.3132z",
    fill: "#43979b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m.117676 58.4815 100.727324 58.1155 100.727-58.1155-100.727-58.115045z",
    fill: "#3f898d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m90.4824 14.3445-73.0376 42.1976c.1658 1.3264.1658 2.57 0 3.8964l73.0376 42.1975c6.1348-4.5595 14.5906-4.5595 20.7256 0l73.038-42.1975c-.166-1.3264-.166-2.57 0-3.8964l-73.038-42.1976c-6.218 4.5596-14.5908 4.5596-20.7256 0z",
    fill: "#51b8bc"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m191.209 72.0448-73.12 42.6122c.829 7.627-3.316 14.84-10.363 17.907l.083 83.898c1.161.497 2.321 1.16 3.399 1.99l73.038-42.198c-.829-7.627 3.316-14.84 10.362-17.907v-84.3125c-1.16-.4974-2.321-1.1607-3.399-1.9897z",
    fill: "#459da2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m10.4808 72.542c-1.07773.7461-2.15547 1.4094-3.39901 1.9897v84.3123c7.04671 3.067 11.19191 10.363 10.36291 17.907l73.0375 42.198c1.0778-.746 2.1555-1.41 3.399-1.99v-84.312c-7.0467-3.068-11.1919-10.363-10.3628-17.907z",
    fill: "#64c1c8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m31.5317 84.4706h-13.4094v64.8674h13.4094z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.9143 149.338v-23.801c3.2685.251 6.6209.251 9.3865.251 19.1084 0 24.6398-9.47 24.6398-21.12 0-14.1632-10.1409-20.1974-25.7293-20.1974h-21.7064v64.8674zm7.2075-32.936c-2.5143 0-6.118 0-7.2913-.084v-22.0418h8.3808c8.0457 0 12.6551 3.8552 12.6551 10.8948v.168c.0838 5.531-1.9276 11.063-13.7446 11.063z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m134.783 84.4706h-40.7308v64.8674h13.4098v-28.578h25.477v-9.722h-25.561v-16.678h26.483z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178.699 97.2101 3.52-8.9675c-5.196-3.7714-12.32-5.1124-21.204-5.1124-12.99 0-23.634 6.0343-23.634 18.4378 0 11.147 8.214 15.505 16.343 18.187l8.213 2.765c5.615 1.928 10.225 3.772 10.225 9.806 0 5.531-4.777 7.71-12.069 7.71-7.375 0-15.253-2.179-19.778-5.028l-3.52 9.722c5.866 3.771 13.325 5.615 23.298 5.615 14.248 0 25.227-6.286 25.227-19.528 0-12.403-9.47-16.342-19.025-19.527l-8.883-2.933c-3.856-1.257-6.789-3.017-6.789-7.962 0-5.0287 4.107-7.0401 10.309-7.0401 7.542-.2514 13.409 1.1733 17.767 3.8552z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIpfs);
export default __webpack_public_path__ + "static/media/ipfs.38588d734ce8c5bb234b88f354eef297.svg";
export { ForwardRef as ReactComponent };